/**
 * Which categories Capture's grid shows, and when the last cell becomes More.
 *
 * Four columns, in the user's own order (Settings). Up to `rows × 4` fit; past
 * that the last cell is **More** and the rest live in a sheet. A category
 * picked from that sheet stands in for the last visible slot, so the selected
 * radio is always inside the radiogroup — a choice that cannot be seen is a
 * Save that writes somewhere invisible.
 *
 * Pure, so the arithmetic is tested without a screen.
 */

export const GRID_COLUMNS = 4;
/** Three rows on a normal phone; two on a short one (320×568), so the numpad and Save still fit. */
export const GRID_ROWS_TALL = 3;
export const GRID_ROWS_SHORT = 2;

export interface GridLayout<T> {
  /** The cells drawn as radios, in order. */
  shown: T[];
  /** How many are behind More (0 = no More cell). */
  hidden: number;
}

export function gridLayout<T extends { id: string }>(
  categories: readonly T[],
  rows: number,
  selectedId: string | null,
): GridLayout<T> {
  const capacity = rows * GRID_COLUMNS;
  if (categories.length <= capacity) return { shown: [...categories], hidden: 0 };

  const slots = capacity - 1; // the last cell is More
  const shown = categories.slice(0, slots);
  const selected = categories.find((c) => c.id === selectedId);
  if (selected && !shown.includes(selected)) shown[slots - 1] = selected;
  return { shown, hidden: categories.length - slots };
}
